import { Component, Inject, OnInit } from '@angular/core';
import { API_ERROR_COPY, friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { FilterService } from 'src/app/services/filter.service';

@Component({
    selector: 'app-server-export-popup',
    templateUrl: './server-export-popup.component.html',
    styleUrls: ['./server-export-popup.component.scss'],
    standalone: false
})
export class ServerExportPopupComponent implements OnInit {
  checklist:any;
  masterSelected=false;
  checkedList:any;
  reqSubcription: Subscription[] = [];

  item: any;
  rowDataCount: any;
  filterValue: any;
  api_status:any;
  searchDynamicParams:any;

  dataLoads= false;
  loaderApi= false;
  visibleData=false;
  /** Shown in the "Failed!" state; replaced with the copy for the actual
   *  failure so an outage and a rejected export no longer read the same. */
  failureMessage: string = API_ERROR_COPY.unknown;
  sortModel:any;
  phiChecked=false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private passedData: any,
    private dialogRef: MatDialogRef<ServerExportPopupComponent>,
    private filterService: FilterService,
    private dataService: DataService
  ) { 

    this.checklist = this.passedData?.column.filter((f: any) => f.field !== "alert" && f.field !== "alert_col_value");
    this.checklist = this.passedData?.column.filter((f: any) => f.field !== "action_column");
    this.item = this.passedData.item;
    this.rowDataCount = this.passedData.rowDataCount;
    this.filterValue = this.passedData.filterValue;
    this.searchDynamicParams = this.passedData.searchDynamicParams;
    this.phiChecked = this.passedData.phiChecked;
    this.sortModel = this.passedData?.sortModel || {};
  }

  ngOnInit(): void {
    // this.isAllSelected();
    this.masterSelected = true;
    this.checkUncheckAll();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isExportSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  isAllSelected() {
    this.masterSelected = this.checklist.every(function(item:any) {
        return item.isExportSelected == true;
      })
    this.getCheckedItemList();
  }
 
  getCheckedItemList(){
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if(this.checklist[i].isExportSelected)
      this.checkedList.push(this.checklist[i]);
    }
    
    if(this.checkedList.length>0) {
      this.checkedList = JSON.stringify(this.checkedList);
    } else {
      this.checkedList = [];
    }
  }

  closeInst() {
    this.dialogRef.close(undefined)
  }

  LoadingText = "";
  warnings = false;

  waringFunc() {
    this.warnings = true;
    this.dataLoads = true;
  }

  selectedExport() {
    this.warnings = false;
    this.loaderApi = true;
    this.dataLoads = true;
    this.LoadingText = "Loading...";
    this.api_status = "";

    if(this.checkedList !== undefined) {
      let data = JSON.parse(this.checkedList);
      if(data.length>0) {
        let column = '';
        data.forEach((f: any, index: number) => {
          column += `${f.field} '${f.headerName}'${index < data.length - 1 ? ',' : ''}`;
          // if(f?.flagBasedBadges && f?.flagBasedBadges?.column_nm) {
          //   column += `${f.flagBasedBadges?.column_nm} '${f.flagBasedBadges?.excel_label}'${index < data.length - 1 ? ',' : ''}`;
          // }
        });
        this.selectedExportXls(column);
      }
    }

    // this.dialogRef.close(this.checkedList)
  }

  selectedExportXls(column:any) {
    let query:any = { ...this.filterService.baseQuery };
    query["export_nm"] = this.item.config['report_heading'];
    query["api_key"] = this.item.config?.["list_of_api"]?.['api_key'] || 6001;
    query["report_typ"] = this.filterService.report_type;
    query["column_nm"] = column;
    query["activity_since_days"] = this.filterService.sliderValue || undefined;
    query["total_records"] = this.rowDataCount;
    
    query["phi_flg"] = this.phiChecked ? "Y" : "N";
    
    if(this.filterValue) {
      Object.assign(query, this.filterValue);
    }

    if(this.searchDynamicParams && Object.keys(this.searchDynamicParams).length>0) {
      Object.assign(query, this.searchDynamicParams);
    }

    if(this.sortModel) {
      Object.assign(query, this.sortModel);
    }

    this.reqSubcription.push(
      this.dataService.getExportCSV(query).pipe(debounceTime(500)).subscribe((res: any) => {
        this.visibleData = true;
        
        if(res?.status) {
          this.LoadingText = "";
          this.api_status = res.status;
          setTimeout(() => {
            this.functionInfo();
          }, 50);
        } else if(res?.pturl) {
          this.LoadingText = "Success!";
          this.api_status = "File has been downloaded successfully!"
          setTimeout(() => {
            this.functionTick();
          }, 50);
          const link = document.createElement('a');
          link.href = res.pturl;
          link.download = (this.item.config['report_heading'] || 'Excel') + '.csv';
          document.body.appendChild(link)
          link.click();
          document.body.removeChild(link);
        }
        
      }, err => {
        console.error('[ServerExportPopup] Export failed', err);
        this.failureMessage = friendlyApiErrorMessage(err);
        this.loaderApi = false;
        this.visibleData = true;
      })
    );
  }

  gotItBack() {
    this.dialogRef.close();
  }

  functionTick() {
    const circleLoader:any = document.querySelector('.circle-loader');
    const checkmark:any = document.querySelector('.checkmark');
    
    circleLoader.classList.toggle('load-complete');
    checkmark.style.display = (checkmark.style.display === 'none' || checkmark.style.display === '') ? 'block' : 'none';
  };
  
  functionInfo() {
    const circleLoader:any = document.querySelector('.circle-loader');
    const infoSymbol:any = document.querySelector('.info-symbol');
    
    circleLoader.classList.toggle('load-complete');
    infoSymbol.style.display = (infoSymbol.style.display === 'none' || infoSymbol.style.display === '') ? 'block' : 'none';
}
}
